import RichUpdatesItemTooltip from './RichUpdatesItemTooltip';

export default RichUpdatesItemTooltip;
